import { AppSelectBox } from 'components';
import SelectBoxV2 from 'components/Inputs/SelectBoxV2';
import { Fragment, forwardRef } from 'react';

function AnalyticsFilterDropdown(
  {
    options = [],
    value,
    handleChange,
    label,
    placeholder = 'Choose',
    labelClass,
    version = 'default',
    isLoading = false,
    isError = false,
    fieldErrors = {},
    defaultLook = true,
    onKeyDown,
    onFocus,
    tabIndex,
    disabled = false,
    ...otherProps
  },
  ref
) {
  const mappedOptions = options.map((o) => ({
    value: o.value,
    label: o.label,
  }));

  const handleKeyDown = (e) => {
    if (onKeyDown) {
      onKeyDown(e);
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const selectElement = e.target;
      if (selectElement && selectElement.click) {
        selectElement.click();
      }
    }
  };

  if (version === 'v2') {
    const selectedOption = mappedOptions.find((o) => o.value === value) ?? null;

    return (
      <SelectBoxV2
        labelProps={{ label, className: labelClass }}
        fieldErrors={fieldErrors}
        selectProps={{
          isLoading,
          isDisabled: disabled,
          options: mappedOptions,
          value: selectedOption,
          getOptionLabel: (opt) => opt.label,
          getOptionValue: (opt) => opt.value,
          onChange: (opt) => {
            handleChange({ target: { value: opt?.value || '' } }, opt);
          },
          onKeyDown: handleKeyDown,
          onFocus: (e) => {
            if (onFocus) {
              onFocus(e);
            }
          },
          tabIndex,
          placeholder,
          menuIsOpen: undefined,
          ...otherProps,
        }}
      />
    );
  }

  // Default version using AppSelectBox
  return (
    <AppSelectBox
      className="analytics-filter-select"
      labelProps={{ label, className: labelClass }}
      selectProps={{
        value,
        disabled: disabled || isLoading,
        onChange: (event) => {
          const sel = event.target.value;
          const opt = options.find((o) => o.value === sel);
          handleChange(event, opt ? { ...opt, value: sel } : null);
        },
        onKeyDown: handleKeyDown,
        onFocus: (e) => {
          if (onFocus) {
            onFocus(e);
          }
        },
        tabIndex,
        ...otherProps,
      }}
      fieldErrors={fieldErrors}
      options={mappedOptions}
      defaultLook={defaultLook}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load options
        </option>
      ) : (
        <Fragment>
          <option value="">{placeholder}</option>
          {mappedOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

AnalyticsFilterDropdown.defaultProps = {
  handleChange: () => {},
};

export default forwardRef(AnalyticsFilterDropdown);
